!function (t, e) {
    "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.ImageScript = e() : t.ImageScript = e()
}(self, (() => {
    return t = {
        860: (t, e, r) => {
            const i = r(205), n = r(3), s = r(584), o = r(338), {version: a} = r(147), h = r(820), l = r(501),
                f = r(193);

            class c {
                constructor(t, e) {
                    if (e = ~~e, (t = ~~t) < 1) throw new RangeError("Image has to be at least 1 pixel wide");
                    if (e < 1) throw new RangeError("Image has to be at least 1 pixel high");
                    this.__width__ = t, this.__height__ = e, this.__buffer__ = new ArrayBuffer(t * e * 4), this.__view__ = new DataView(this.__buffer__), this.__u32__ = new Uint32Array(this.__buffer__), this.bitmap = new Uint8ClampedArray(this.__buffer__)
                }

                toString() {
                    return `Image<${this.width}x${this.height}>`
                }

                get width() {
                    return this.__width__
                }

                get height() {
                    return this.__height__
                }

                * [Symbol.iterator]() {
                    for (let t = 1; t <= this.height; t++) for (let e = 1; e <= this.width; e++) yield[e, t]
                }

                * iterateWithColors() {
                    let t = 0;
                    for (let e = 1; e <= this.height; e++) for (let r = 1; r <= this.width; r++) yield[r, e, this.__view__.getUint32(t, !1)], t += 4
                }

                static rgbaToColor(t, e, r, i) {
                    return ((255 & t) << 24 | (255 & e) << 16 | (255 & r) << 8 | 255 & i) >>> 0
                }

                static rgbToColor(t, e, r) {
                    return c.rgbaToColor(t, e, r, 255)
                }

                static hslaToColor(t, e, r, i) {
                    let n, s, o;
                    if (t %= 1, e = Math.min(1, Math.max(0, e)), r = Math.min(1, Math.max(0, r)), i = Math.min(1, Math.max(0, i)), 0 === e) n = s = o = r; else {
                        const i = (t, e, r) => (r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t),
                            a = r < .5 ? r * (1 + e) : r + e - r * e, h = 2 * r - a;
                        n = i(h, a, t + 1 / 3), s = i(h, a, t), o = i(h, a, t - 1 / 3)
                    }
                    return c.rgbaToColor(255 * n, 255 * s, 255 * o, 255 * i)
                }

                static hslToColor(t, e, r) {
                    return c.hslaToColor(t, e, r, 1)
                }

                static rgbaToHSLA(t, e, r, i) {
                    t /= 255, e /= 255, r /= 255;
                    const n = Math.max(t, e, r), s = Math.min(t, e, r);
                    let o, a, h = (n + s) / 2;
                    if (n === s) o = a = 0; else {
                        const i = n - s;
                        switch (a = h > .5 ? i / (2 - n - s) : i / (n + s), n) {
                            case t:
                                o = (e - r) / i + (e < r ? 6 : 0);
                                break;
                            case e:
                                o = (r - t) / i + 2;
                                break;
                            case r:
                                o = (t - e) / i + 4
                        }
                        o /= 6
                    }
                    return [o, a, h, i / 255]
                }

                static colorToRGBA(t) {
                    return [t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t]
                }

                static colorToRGB(t) {
                    return c.colorToRGBA(t).slice(0, 3)
                }

                getPixelAt(t, e) {
                    return this.__check_boundaries__(t, e), this.__view__.getUint32(4 * ((~~e - 1) * this.width + (~~t - 1)), !1)
                }

                getRGBAAt(t, e) {
                    this.__check_boundaries__(t, e);
                    const r = 4 * ((~~e - 1) * this.width + (~~t - 1));
                    return this.bitmap.subarray(r, r + 4)
                }

                setPixelAt(t, e, r) {
                    return t = ~~t, e = ~~e, this.__check_boundaries__(t, e), this.__set_pixel__(t, e, r), this
                }

                __set_pixel__(t, e, r) {
                    this.__view__.setUint32(4 * ((e - 1) * this.width + (t - 1)), r, !1)
                }

                __check_boundaries__(t, e) {
                    if (isNaN(t)) throw new TypeError(`Invalid pixel coordinates (x=${t})`);
                    if (isNaN(e)) throw new TypeError(`Invalid pixel coordinates (y=${e})`);
                    if (t < 1) throw new RangeError(`${c.__out_of_bounds__} (x=${t})<1`);
                    if (t > this.width) throw new RangeError(`${c.__out_of_bounds__} (x=${t})>(width=${this.width})`);
                    if (e < 1) throw new RangeError(`${c.__out_of_bounds__} (y=${e})<1`);
                    if (e > this.height) throw new RangeError(`${c.__out_of_bounds__} (y=${e})>(height=${this.height})`)
                }

                static get __out_of_bounds__() {
                    return "Tried referencing a pixel outside of the images boundaries:"
                }

                fill(t) {
                    if ("function" != typeof t) this.__view__.setUint32(0, t, !1), this.__u32__.fill(this.__u32__[0]); else {
                        let e = 0;
                        for (let r = 1; r <= this.height; r++) for (let i = 1; i <= this.width; i++) this.__view__.setUint32(e, t(i, r), !1), e += 4
                    }
                    return this
                }

                clone() {
                    const t = new c(this.width, this.height);
                    return t.bitmap.set(this.bitmap), t
                }

                static get RESIZE_NEAREST_NEIGHBOR() {
                    return "RESIZE_NEAREST_NEIGHBOR"
                }

                static get RESIZE_AUTO() {
                    return -1
                }

                scale(t, e = c.RESIZE_NEAREST_NEIGHBOR) {
                    const r = this.__scale__(t, e);
                    return this.__apply__(r)
                }

                __scale__(t, e = c.RESIZE_NEAREST_NEIGHBOR) {
                    return 1 === t ? this : this.__resize__(this.width * t, this.height * t, e)
                }

                resize(t, e, r = c.RESIZE_NEAREST_NEIGHBOR) {
                    const i = this.__resize__(t, e, r);
                    return this.__apply__(i)
                }

                contain(t, e, r = c.RESIZE_NEAREST_NEIGHBOR) {
                    const i = t / e > this.width / this.height ? e / this.height : t / this.width;
                    return this.scale(i, r)
                }

                fit(t, e, r = c.RESIZE_NEAREST_NEIGHBOR) {
                    const i = new c(t, e);
                    return this.contain(t, e, r), i.composite(this, (t - this.width) / 2, (e - this.height) / 2), this.__apply__(i)
                }

                cover(t, e, r = c.RESIZE_NEAREST_NEIGHBOR) {
                    const i = t / e > this.width / this.height ? t / this.width : e / this.height, n = this.scale(i, r);
                    return n.crop((n.width - t) / 2, (n.height - e) / 2, t, e)
                }

                __resize__(t, e, r = c.RESIZE_NEAREST_NEIGHBOR) {
                    if (t === c.RESIZE_AUTO && e === c.RESIZE_AUTO) throw new Error("RESIZE_AUTO can only be used for either width or height, not for both");
                    if (t === c.RESIZE_AUTO ? t = this.width / this.height * e : e === c.RESIZE_AUTO && (e = this.height / this.width * t), t = Math.floor(t), e = Math.floor(e), t < 1) throw new RangeError("Image has to be at least 1 pixel wide");
                    if (e < 1) throw new RangeError("Image has to be at least 1 pixel high");
                    let i;
                    if (r !== c.RESIZE_NEAREST_NEIGHBOR) throw new Error("Invalid resize mode");
                    return i = this.__resize_nearest_neighbor__(t, e), i
                }

                __resize_nearest_neighbor__(t, e) {
                    const r = new this.constructor(t, e);
                    for (let i = 0; i < e; i++) for (let n = 0; n < t; n++) {
                        const s = Math.floor(i * this.height / e), o = Math.floor(n * this.width / t),
                            a = 4 * (i * t + n), h = 4 * (s * this.width + o);
                        r.__view__.setUint32(a, this.__view__.getUint32(h, !1), !1)
                    }
                    return r
                }

                crop(t, e, r, i) {
                    return r > this.width && (r = this.width), i > this.height && (i = this.height), this.__apply__(this.__crop__(~~t, ~~e, ~~r, ~~i))
                }

                __crop__(t, e, r, i) {
                    t = ~~t, e = ~~e;
                    const n = new this.constructor(r, i);
                    for (let s = 0; s < i; s++) {
                        const i = (s + e) * this.width + t;
                        n.__u32__.set(this.__u32__.subarray(i, i + r), s * r)
                    }
                    return n
                }

                drawBox(t, e, r, i, n) {
                    if (t = ~~(t - 1), e = ~~(e - 1), r = ~~r, i = ~~i, "function" != typeof n) return this.__fast_box__(t, e, r, i, n);
                    for (let s = 1; s <= i; s++) for (let i = 1; i <= r; i++) {
                        const r = i + t, o = s + e;
                        if (Math.min(r, o) < 1 || r > this.width || o > this.height) continue;
                        const a = n(i, s);
                        this.__set_pixel__(r, o, a)
                    }
                    return this
                }

                __fast_box__(t, e, r, i, n) {
                    t < 0 && (r += t, t = 0), e < 0 && (i += e, e = 0);
                    const s = Math.max(Math.min(t + r, this.width), 1);
                    let o = s;
                    for (; t <= --o;) this.__view__.setUint32(4 * (o + e * this.width), n);
                    const a = 4 * (s + e * this.width), h = 4 * (t + e * this.width);
                    let l = Math.max(Math.min(e + i, this.height), 1);
                    for (; e < --l;) this.bitmap.copyWithin(4 * (t + l * this.width), h, a);
                    return this
                }

                drawCircle(t, e, r, i) {
                    const n = r ** 2;
                    for (let s = Math.max(1, e - r); s <= Math.min(e + r, this.height); s++) for (let o = Math.max(1, t - r); o <= Math.min(t + r, this.width); o++) (o - t) ** 2 + (s - e) ** 2 < n && this.__set_pixel__(o, s, "function" == typeof i ? i(o - t + r, s - e + r) : i);
                    return this
                }

                cropCircle(t = !1, e = 0) {
                    const r = (Math[t ? "max" : "min"](this.width, this.height) / 2) ** 2, i = this.width / 2,
                        n = this.height / 2;
                    for (const [t, s] of this) {
                        const o = (t - i) ** 2 + (s - n) ** 2, a = 4 * ((s - 1) * this.width + (t - 1)) + 3;
                        o > r ? this.bitmap[a] = 0 : e && (this.bitmap[a] *= Math.max(0, Math.min(1, 1 - o / r * e ** .5)))
                    }
                    return this
                }

                opacity(t, e = !1) {
                    if (isNaN(t) || t < 0) throw new RangeError("Invalid opacity value");
                    return this.__set_channel_value__(t, e, 3), this
                }

                red(t, e = !1) {
                    if (isNaN(t) || t < 0) throw new RangeError("Invalid saturation value");
                    return this.__set_channel_value__(t, e, 0), this
                }

                green(t, e = !1) {
                    if (isNaN(t) || t < 0) throw new RangeError("Invalid saturation value");
                    return this.__set_channel_value__(t, e, 1), this
                }

                blue(t, e = !1) {
                    if (isNaN(t) || t < 0) throw new RangeError("Invalid saturation value");
                    return this.__set_channel_value__(t, e, 2), this
                }

                __set_channel_value__(t, e, r) {
                    for (let i = r; i < this.bitmap.length; i += 4) this.bitmap[i] = t * (e ? 255 : this.bitmap[i])
                }

                lightness(t, e = !1) {
                    if (isNaN(t) || t < 0) throw new RangeError("Invalid lightness value");
                    return this.fill(((r, i) => {
                        const [n, s, o, a] = c.rgbaToHSLA(...this.getRGBAAt(r, i));
                        return c.hslaToColor(n, s, t * (e ? 1 : o), a)
                    }))
                }

                saturation(t, e = !1) {
                    if (isNaN(t) || t < 0) throw new RangeError("Invalid saturation value");
                    return this.fill(((r, i) => {
                        const [n, s, o, a] = c.rgbaToHSLA(...this.getRGBAAt(r, i));
                        return c.hslaToColor(n, t * (e ? 1 : s), o, a)
                    }))
                }

                composite(t, e = 0, r = 0) {
                    e = ~~e, r = ~~r;
                    for (let i = 0; i < t.height; i++) {
                        let n = r + i;
                        if (!(n < 0)) {
                            if (n >= this.height) break;
                            for (let r = 0; r < t.width; r++) {
                                let s = e + r;
                                if (s < 0) continue;
                                if (s >= this.width) break;
                                const o = 4 * (s + n * this.width), a = t.__view__.getUint32(4 * (r + i * t.width), !1),
                                    h = this.__view__.getUint32(o, !1);
                                255 == (255 & a) ? this.__view__.setUint32(o, a, !1) : 0 == (255 & a) ? this.__view__.setUint32(o, h, !1) : this.__view__.setUint32(o, c.__alpha_blend__(a, h), !1)
                            }
                        }
                    }
                    return this
                }

                static __alpha_blend__(t, e) {
                    const r = 255 & t, i = r + 1, n = 256 - r;
                    return (255 & i * (t >>> 24) + n * (e >>> 24) >> 8) << 24 | (255 & i * (t >> 16 & 255) + n * (e >> 16 & 255) >> 8) << 16 | (255 & i * (t >> 8 & 255) + n * (e >> 8 & 255) >> 8) << 8 | 255 & Math.max(r, 255 & e)
                }

                invert() {
                    for (const [t, e, r] of this.iterateWithColors()) this.__set_pixel__(t, e, 4294967295 - r & 4294967040 | 255 & r);
                    return this
                }

                invertValue() {
                    for (const [t, e, r] of this.iterateWithColors()) {
                        const [i, n, s, o] = c.rgbaToHSLA(...c.colorToRGBA(r));
                        this.__set_pixel__(t, e, c.hslaToColor(i, n, 1 - s, o))
                    }
                    return this
                }

                invertSaturation() {
                    for (const [t, e, r] of this.iterateWithColors()) {
                        const [i, n, s, o] = c.rgbaToHSLA(...c.colorToRGBA(r));
                        this.__set_pixel__(t, e, c.hslaToColor(i, 1 - n, s, o))
                    }
                    return this
                }

                invertHue() {
                    for (const [t, e, r] of this.iterateWithColors()) {
                        const [i, n, s, o] = c.rgbaToHSLA(...c.colorToRGBA(r));
                        this.__set_pixel__(t, e, c.hslaToColor(1 - i, n, s, o))
                    }
                    return this
                }

                hueShift(t) {
                    for (const [e, r, i] of this.iterateWithColors()) {
                        const [n, s, o, a] = c.rgbaToHSLA(...c.colorToRGBA(i));
                        this.__set_pixel__(e, r, c.hslaToColor(n + t / 360, s, o, a))
                    }
                    return this
                }

                averageColor() {
                    let t = [0, 0, 0], e = 0;
                    for (let r = 0; r < this.bitmap.length; r += 4) {
                        const i = this.bitmap.subarray(r, r + 4);
                        for (let e = 0; e < 3; e++) t[e] += i[e];
                        e += i[3] / 255
                    }
                    return c.rgbaToColor(...t.map((t => t / e)), 255)
                }

                dominantColor(t = !0, e = !0, r = 15) {
                    const i = new Array(262143);
                    for (let n = 0; n < this.bitmap.length; n += 4) {
                        const s = this.__view__.getUint32(n, !1), [o, a, h] = c.rgbaToHSLA(...c.colorToRGBA(s)).map((t => ~~(63 * t)));
                        if (t && h < r) continue;
                        if (e && h > 63 - r) continue;
                        const l = o << 12 | a << 6 | h;
                        i[l] = (i[l] || 0) + 1
                    }
                    let n = -1, s = 0;
                    if (i.forEach(((t, e) => {
                        t < n || (n = t, s = e)
                    })), -1 === s) return this.dominantColor(t, e, r - 1);
                    const o = s >>> 12 & 63, a = s >>> 6 & 63, h = 63 & s;
                    return c.hslaToColor(o / 63, a / 63, h / 63, 1)
                }

                rotate(t, e = !0) {
                    if (t % 360 == 0) return this;
                    if (t % 180 == 0) return this.__rotate_180__();
                    const r = Math.PI * (t / 180), i = Math.sin(r), n = Math.cos(r),
                        s = e ? Math.abs(this.width * i) + Math.abs(this.height * n) : this.width,
                        o = e ? Math.abs(this.width * n) + Math.abs(this.height * i) : this.height, a = new c(s, o),
                        h = s / 2 - .5, l = o / 2 - .5, f = this.width / 2 - .5, _ = this.height / 2 - .5;
                    let u = 0;
                    do {
                        let t = 0;
                        const e = f - i * (u - l), r = _ + n * (u - l);
                        do {
                            const s = e + n * (t - h), o = r + i * (t - h);
                            c.__interpolate__(this, a, t, u, s, o)
                        } while (t++ < s)
                    } while (u++ < o);
                    return this.__apply__(a)
                }

                __rotate_180__() {
                    let t = 0;
                    for (this.bitmap.reverse(); t < this.bitmap.length;) this.bitmap.subarray(t, t += 4).reverse();
                    return this
                }

                static __interpolate__(t, e, r, i, n, s) {
                    const o = ~~n, a = ~~s, h = n - o, l = s - a, f = e.bitmap.subarray(4 * (r + i * e.width), -4),
                        _ = {r: 0, g: 0, b: 0, a: 0};
                    c.__pawn__(o, a, (1 - h) * (1 - l), _, t), c.__pawn__(1 + o, a, h * (1 - l), _, t), c.__pawn__(o, 1 + a, (1 - h) * l, _, t), c.__pawn__(1 + o, 1 + a, h * l, _, t), f[3] = _.a, f[0] = _.r / _.a, f[1] = _.g / _.a, f[2] = _.b / _.a
                }

                static __pawn__(t, e, r, i, n) {
                    if (t > 0 && e > 0 && t < n.width && e < n.height) {
                        const s = 4 * (t + e * n.width), o = n.bitmap.subarray(s, s + 4), a = r * o[3];
                        i.a += a, i.r += a * o[0], i.g += a * o[1], i.b += a * o[2]
                    }
                }

                __apply__(t) {
                    return this.__width__ = t.__width__, this.__height__ = t.__height__, this.__view__ = t.__view__, this.__u32__ = t.__u32__, this.bitmap = t.bitmap, t instanceof _ ? _.from(this, t.duration, t.xOffset, t.yOffset, t.disposalMode) : this
                }

                static gradient(t) {
                    const e = Object.entries(t).sort(((t, e) => t[0] - e[0])), r = e.map((t => parseFloat(t[0]))),
                        i = e.map((t => t[1]));
                    if (0 === r.length) throw new RangeError("Invalid gradient point count");
                    if (1 === r.length) return () => i[0];
                    if (2 === r.length) {
                        const t = this.__gradient__(i[0], i[1]);
                        return e => e <= r[0] ? i[0] : e >= r[1] ? i[1] : t((e - r[0]) / (r[1] - r[0]))
                    }
                    const n = Math.min(...r), s = Math.max(...r);
                    let o = [];
                    for (let t = 0; t < r.length; t++) {
                        let e = r[t - 1];
                        if (void 0 === e) continue;
                        let n = r[t], s = i[t - 1];
                        void 0 === s && (s = i[t]);
                        const a = i[t], h = this.__gradient__(s, a);
                        o.push({min: e, max: n, gradient: h})
                    }
                    return t => {
                        if (t <= n) return o[0].gradient(0);
                        if (t >= s) return o[o.length - 1].gradient(1);
                        for (const e of o) if (t >= e.min && t <= e.max) return e.gradient((t - e.min) / (e.max - e.min));
                        throw new RangeError(`Invalid gradient position: ${t}`)
                    }
                }

                roundCorners(t = Math.min(this.width, this.height) / 4) {
                    const e = t ** 2;
                    for (let r = 1; r <= t; r++) {
                        const i = (r - t) ** 2;
                        for (let n = 1; n <= t; n++) i + (n - t) ** 2 > e && (this.bitmap[4 * ((n - 1) * this.width + r - 1) + 3] = 0)
                    }
                    for (let r = 1; r <= t; r++) {
                        const i = (r - t) ** 2;
                        for (let n = this.height - t; n <= this.height; n++) i + (this.height - n - t) ** 2 > e && (this.bitmap[4 * ((n - 1) * this.width + r - 1) + 3] = 0)
                    }
                    for (let r = this.width - t; r <= this.width; r++) {
                        const i = (this.width - r - t) ** 2;
                        for (let n = 1; n <= t; n++) i + (n - t) ** 2 > e && (this.bitmap[4 * ((n - 1) * this.width + r - 1) + 3] = 0)
                    }
                    for (let r = this.width - t; r <= this.width; r++) {
                        const i = (this.width - r - t) ** 2;
                        for (let n = this.height - t; n <= this.height; n++) i + (this.height - n - t) ** 2 > e && (this.bitmap[4 * ((n - 1) * this.width + r - 1) + 3] = 0)
                    }
                    return this
                }

                static __gradient__(t, e) {
                    const r = t >>> 24, i = t >> 16 & 255, n = t >> 8 & 255, s = 255 & t, o = (e >>> 24) - r,
                        a = (e >> 16 & 255) - i, h = (e >> 8 & 255) - n, l = (255 & e) - s;
                    return t => (255 & r + t * o) << 24 | (255 & i + t * a) << 16 | (255 & n + t * h) << 8 | 255 & s + t * l
                }

                fisheye(t = 2) {
                    const e = new c(this.width, this.height), r = this.width, i = this.height, n = this.__u32__,
                        s = e.__u32__, o = 1 / r, a = 1 / i;
                    for (const [e, h] of this) {
                        const l = e * o - .5, f = h * a - .5, c = Math.sqrt(l ** 2 + f ** 2), _ = 2 * c ** t,
                            u = (_ * l / c + .5) * r | 0, w = (_ * f / c + .5) * i | 0;
                        u < 1 || u > r || w < 1 || w > i || isNaN(u) || isNaN(w) || (s[h * r + e] = n[r * w + u])
                    }
                    const h = .5 * n.length + r / 2;
                    return s[h] = n[h], this.__apply__(e)
                }

                async encode(t = 1, {
                    title: e,
                    author: r,
                    description: n,
                    copyright: s,
                    creationTime: o,
                    software: h,
                    disclaimer: l,
                    warning: f,
                    source: c,
                    comment: _
                } = {}) {
                    return i.encode(this.bitmap, {
                        width: this.width,
                        height: this.height,
                        level: t,
                        channels: 4,
                        text: {
                            Title: e,
                            Author: r,
                            Description: n,
                            Copyright: s,
                            "Creation Time": new Date(void 0 === o ? Date.now() : o).toUTCString(),
                            Software: void 0 === h ? `github.com/matmen/ImageScript v${a}` : h,
                            Disclaimer: l,
                            Warning: f,
                            Source: c,
                            Comment: _
                        }
                    })
                }

                async encodeJPEG(t = 90) {
                    return (await l.init()).encode(this.bitmap, this.width, this.height, t)
                }

                static async decode(t) {
                    let e;
                    t = n.view(t);
                    const r = new DataView(t.buffer, t.byteOffset, t.byteLength);
                    if (g.isPNG(r)) {
                        const {width: r, height: n, pixels: s} = i.decode(t);
                        e = new c(r, n), e.bitmap.set(s)
                    } else if (g.isJPEG(r)) {
                        const r = (await l.init()).decode(t), i = r.width, n = r.height, s = r.format;
                        e = new c(i, n);
                        const o = r.buffer;
                        if (0 === s) {
                            const t = new DataView(e.bitmap.buffer);
                            for (let e = 0; e < o.length; e++) {
                                const r = o[e];
                                t.setUint32(4 * e, r << 24 | r << 16 | r << 8 | 255, !1)
                            }
                        } else if (1 === s) {
                            e.bitmap.fill(255);
                            for (let t = 0; t < i * n; t++) e.bitmap.set(o.subarray(3 * t, 3 * t + 3), 4 * t)
                        } else if (2 === s) for (let t = 0; t < o.length; t += 4) e.bitmap[t] = 255 * (1 - o[t] / 255) * (1 - o[t + 3] / 255), e.bitmap[t + 1] = 255 * (1 - o[t + 1] / 255) * (1 - o[t + 3] / 255), e.bitmap[t + 2] = 255 * (1 - o[t + 2] / 255) * (1 - o[t + 3] / 255), e.bitmap[t + 3] = 255
                    } else {
                        if (!g.isTIFF(r)) throw new Error("Unsupported image type");
                        {
                            const r = (await f.init()).decode(t);
                            e = new c(r.width, r.height), e.bitmap.set(r.buffer)
                        }
                    }
                    return e
                }

                static get SVG_MODE_SCALE() {
                    return 1
                }

                static get SVG_MODE_WIDTH() {
                    return 2
                }

                static get SVG_MODE_HEIGHT() {
                    return 3
                }

                static async renderSVG(t, e = 1, r = this.SVG_MODE_SCALE) {
                    if (![this.SVG_MODE_WIDTH, this.SVG_MODE_HEIGHT, this.SVG_MODE_SCALE].includes(r)) throw new Error("Invalid SVG scaling mode");
                    if (r === this.SVG_MODE_SCALE && e <= 0) throw new RangeError("SVG scale must be > 0");
                    if (r !== this.SVG_MODE_SCALE && e < 1) throw new RangeError("SVG size must be >= 1");
                    "string" == typeof t && (t = (new TextEncoder).encode(t));
                    const i = (await o.init()).rasterize(t, r, e), n = new c(i.width, i.height);
                    return n.bitmap.set(i.buffer), n
                }

                static async renderText(t, e, r, i = 4294967295, n = new w) {
                    const {Font: s, Layout: o} = await h.init();
                    t = new s(e, t);
                    const [a, l, f, _] = c.colorToRGBA(i), u = new o;
                    u.reset({
                        max_width: n.maxWidth,
                        max_height: n.maxHeight,
                        wrap_style: n.wrapStyle,
                        vertical_align: n.verticalAlign,
                        horizontal_align: n.horizontalAlign,
                        wrap_hard_breaks: n.wrapHardBreaks
                    }), u.append(t, r, {scale: e});
                    const g = u.rasterize(a, l, f), d = new c(g.width, g.height);
                    return d.bitmap.set(g.buffer), d.height > n.maxHeight && d.crop(0, 0, d.width, Math.floor(u.lines() / d.height * n.maxHeight) * (d.height / u.lines())), t.free(), u.free(), d.opacity(_ / 255)
                }
            }

            class _ extends c {
                static get DISPOSAL_KEEP() {
                    return "keep"
                }

                static get DISPOSAL_PREVIOUS() {
                    return "previous"
                }

                static get DISPOSAL_BACKGROUND() {
                    return "background"
                }

                static __convert_disposal_mode__(t) {
                    if ("string" == typeof t && (t = ["any", "keep", "previous", "background"].indexOf(t)), t < 0 || t > 3) throw new RangeError("Invalid disposal mode");
                    return t
                }

                constructor(t, e, r = 100, i = 0, n = 0, s = _.DISPOSAL_KEEP) {
                    if (isNaN(r) || r < 0) throw new RangeError("Invalid frame duration");
                    super(t, e), this.duration = r, this.xOffset = i, this.yOffset = n, this.disposalMode = s
                }

                get disposalMode() {
                    return this.__disposalMode__
                }

                set disposalMode(t) {
                    this.__disposalMode__ = _.__convert_disposal_mode__(t)
                }

                toString() {
                    return `Frame<${this.width}x${this.height}x${this.duration}ms>`
                }

                static from(t, e, r, i, n = _.DISPOSAL_KEEP) {
                    if (!(t instanceof c)) throw new TypeError("Invalid image passed");
                    const s = new _(t.width, t.height, e, r, i, n);
                    return s.bitmap.set(t.bitmap), s
                }

                resize(t, e, r = c.RESIZE_NEAREST_NEIGHBOR) {
                    const i = this.width, n = this.height, s = super.resize(t, e, r);
                    return this.xOffset *= s.width / i, this.yOffset *= s.height / n, s
                }
            }

            class u extends Array {
                constructor(t, e = -1) {
                    super(...t);
                    for (const t of this) if (!(t instanceof _)) throw new TypeError(`Frame ${this.indexOf(t)} is not an instance of Frame`);
                    if (e < -1 || isNaN(e)) throw new RangeError("Invalid loop count");
                    this.loopCount = e
                }

                get width() {
                    let t = 0;
                    for (const e of this) {
                        let r = e.width + e.xOffset;
                        t < r && (t = r)
                    }
                    return t
                }

                get height() {
                    let t = 0;
                    for (const e of this) {
                        let r = e.height + e.yOffset;
                        t < r && (t = r)
                    }
                    return t
                }

                toString() {
                    return `GIF<${this.width}x${this.height}x${this.duration}ms>`
                }

                * [Symbol.iterator]() {
                    for (let t = 0; t < this.length; t++) yield this[t]
                }

                slice(t, e) {
                    e === 1 / 0 && (e = this.length);
                    const r = new Array(e - t);
                    for (let e = 0; e < r.length; e++) r[e] = this[e + t];
                    return new u(r, this.loopCount)
                }

                get duration() {
                    return this.reduce(((t, e) => t + e.duration), 0)
                }

                async encode(t = 95) {
                    const e = new ((await s.init()).Encoder)(this.width, this.height, this.loopCount);
                    for (const r of this) {
                        if (!(r instanceof _)) throw new Error("GIF contains invalid frames");
                        e.add(r.xOffset, r.yOffset, ~~(r.duration / 10), r.width, r.height, r.bitmap, r.disposalMode, t / 100 * 29 + 1)
                    }
                    return e.u8()
                }

                static async decode(t, e = !1) {
                    let r;
                    t = n.view(t);
                    const i = new DataView(t.buffer, t.byteOffset, t.byteLength);
                    if (!g.isGIF(i)) throw new Error("Unsupported image type");
                    {
                        const i = [], n = new ((await s.init()).Decoder)(t);
                        if (e) {
                            const t = n.frames().next().value,
                                e = new _(t.width, t.height, 10 * t.delay, t.x, t.y, t.dispose);
                            e.bitmap.set(t.buffer), i.push(e), r = new u(i)
                        }
                        const o = 0 | n.width, a = 0 | n.height, h = new Uint32Array(n.width * n.height),
                            l = new Uint8Array(h.buffer, h.byteOffset, h.byteLength);
                        for (const t of n.frames()) {
                            let e = 0, r = 0;
                            const n = 0 | t.x, s = 0 | t.y, f = t.buffer, c = t.dispose, u = 0 | t.width,
                                w = 0 | t.height, g = new Uint32Array(f.buffer, f.byteOffset, u * w),
                                d = i[i.push(new _(o, a, 10 * t.delay, 0, 0, 3)) - 1].bitmap,
                                p = new Uint32Array(d.buffer);
                            if (d.set(l), 2 === c) for (let t = 0; t < w; t++) {
                                const i = n + o * (t + s) | 0;
                                for (let t = 0; t < u; t++) {
                                    const n = t + i;
                                    0 === f[3 + e] ? p[n] = h[n] : p[n] = g[r], r++, e += 4
                                }
                            } else if (3 === c) for (let t = 0; t < w; t++) {
                                const i = n + o * (t + s) | 0;
                                for (let t = 0; t < u; t++) {
                                    const n = t + i;
                                    0 === f[3 + e] ? p[n] = h[n] : p[n] = g[r], r++, e += 4, h[n] = 0
                                }
                            } else if (0 === c || 1 === c) {
                                d.set(l);
                                for (let t = 0; t < w; t++) {
                                    const i = n + o * (t + s) | 0;
                                    for (let t = 0; t < u; t++) {
                                        const n = t + i;
                                        0 === f[3 + e] ? p[n] = h[n] : p[n] = g[r], r++, e += 4, h[n] = p[n]
                                    }
                                }
                            }
                        }
                        r = new u(i)
                    }
                    return r
                }

                resize(t, e, r = c.RESIZE_NEAREST_NEIGHBOR) {
                    for (const i of this) i.resize(t, e, r)
                }
            }

            class w {
                constructor(t) {
                    const {
                        maxWidth: e,
                        maxHeight: r,
                        wrapStyle: i,
                        verticalAlign: n,
                        horizontalAlign: s,
                        wrapHardBreaks: o
                    } = t || {};
                    if (this.maxWidth = e || 1 / 0, isNaN(this.maxWidth) || this.maxWidth < 1) throw new RangeError("Invalid maxWidth");
                    if (this.maxHeight = r || 1 / 0, isNaN(this.maxHeight) || this.maxHeight < 1) throw new RangeError("Invalid maxHeight");
                    if (this.wrapStyle = i || "word", !["word", "char"].includes(this.wrapStyle)) throw new RangeError("Invalid wrapStyle");
                    if (this.verticalAlign = n || "left", !["left", "center", "right"].includes(this.verticalAlign)) throw new RangeError("Invalid verticalAlign");
                    if (this.horizontalAlign = s || "top", !["top", "middle", "bottom"].includes(this.horizontalAlign)) throw new RangeError("Invalid horizontalAlign");
                    if (this.wrapHardBreaks = void 0 === o || o, "boolean" != typeof this.wrapHardBreaks) throw new TypeError("Invalid wrapHardBreaks")
                }
            }

            class g {
                static getType(t) {
                    let e;
                    return ArrayBuffer.isView(t) ? (t = new Uint8Array(t.buffer, t.byteOffset, t.byteLength), e = new DataView(t.buffer, t.byteOffset, t.byteLength)) : (t = new Uint8Array(t), e = new DataView(t.buffer)), this.isPNG(e) ? "png" : this.isJPEG(e) ? "jpeg" : this.isTIFF(e) ? "tiff" : this.isGIF(e) ? "gif" : null
                }

                static isPNG(t) {
                    return 2303741511 === t.getUint32(0, !1)
                }

                static isJPEG(t) {
                    return t.getUint32(0, !1) >>> 8 == 16767231
                }

                static isTIFF(t) {
                    return 1229531648 === t.getUint32(0, !1)
                }

                static isGIF(t) {
                    return t.getUint32(0, !1) >>> 8 == 4671814
                }
            }

            t.exports = {
                Image: c, GIF: u, Frame: _, TextLayout: w, ImageType: g, decode: function (t, e) {
                    return "gif" === g.getType(t) ? u.decode(t, e) : c.decode(t)
                }
            }
        }, 3: t => {
            function e(t, e = !1) {
                if (t instanceof ArrayBuffer) return new Uint8Array(t);
                if ("undefined" != typeof SharedArrayBuffer && e && t instanceof SharedArrayBuffer) return new Uint8Array(t);
                if (ArrayBuffer.isView(t)) return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
                throw new TypeError("The provided value is not of type '(ArrayBuffer or ArrayBufferView)'")
            }

            t.exports = {
                view: e, from_parts: function (t, r = !1) {
                    let i = 0, n = 0;
                    t.forEach((t => i += null == t.byteLength ? t.length : t.byteLength));
                    const s = new Uint8Array(r ? new SharedArrayBuffer(i) : i);
                    return t.forEach((t => {
                        const r = Array.isArray(t) ? t : e(t, !0);
                        s.set(r, n), n += r.length
                    })), s
                }
            }
        }, 546: t => {
            const e = new Uint32Array([0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117]);
            t.exports = function (t) {
                let r = 0, i = -1;
                const n = t.length - 4 | 0;
                for (; n > r;) i = e[255 & (i ^ t[r++])] ^ i >>> 8, i = e[255 & (i ^ t[r++])] ^ i >>> 8, i = e[255 & (i ^ t[r++])] ^ i >>> 8, i = e[255 & (i ^ t[r++])] ^ i >>> 8;
                for (; r < t.length;) i = e[255 & (i ^ t[r++])] ^ i >>> 8;
                return (4294967295 ^ i) >>> 0
            }
        }, 205: (t, e, r) => {
            const i = r(3), n = r(546), {compress: s, decompress: o} = r(223), a = new Uint8Array([73, 72, 68, 82]),
                h = new Uint8Array([73, 68, 65, 84]), l = new Uint8Array([73, 69, 78, 68]),
                f = n(new Uint8Array([73, 69, 78, 68])), c = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]),
                _ = {1: 0, 2: 4, 3: 2, 4: 6}, u = new TextEncoder;
            t.exports = {
                encode(t, {text: e, width: r, height: o, channels: w, depth: g = 8, level: d = 0}) {
                    let p = 0, m = 0;
                    const b = r * w, y = new Uint8Array(o + t.length);
                    for (; p < t.length;) y[m++] = 0, y.set(t.subarray(p, p += b), m), m += b;
                    if (e) {
                        let t = [];
                        for (const r in e) {
                            if (!e[r]) continue;
                            const i = u.encode(r), s = u.encode(e[r]), o = new Uint8Array(13 + i.length + s.length),
                                a = new DataView(o.buffer);
                            o[4] = 116, o[5] = 69, o[6] = 88, o[7] = 116, o.set(i, 8), t.push(o), o.set(s, 9 + i.length), a.setUint32(0, o.length - 12), a.setUint32(o.length - 4, n(o.subarray(4, o.length - 4)))
                        }
                        e = i.from_parts(t)
                    }
                    p = e ? e.length : 0;
                    const v = s(y, d), E = new Uint8Array(49 + p + c.length + v.length);
                    E[26] = 0, E[27] = 0, E[28] = 0, E[24] = g, E.set(c, 0), E.set(a, 12), E.set(h, 37), E.set(v, 41), E[25] = _[w], e && E.set(e, 45 + v.length), E.set(l, 49 + p + v.length);
                    const A = new DataView(E.buffer);
                    return A.setUint32(8, 13), A.setUint32(16, r), A.setUint32(20, o), A.setUint32(33, v.length), A.setUint32(45 + p + v.length, 0), A.setUint32(53 + p + v.length, f), A.setUint32(29, n(new Uint8Array(E.buffer, 12, 17))), A.setUint32(41 + v.length, n(new Uint8Array(E.buffer, 37, 4 + v.length))), E
                }, decode(t) {
                    let e = new DataView(t.buffer, t.byteOffset, t.byteLength);
                    const r = e.getUint32(16), n = e.getUint32(20), s = t[24], a = t[25];
                    let h = {3: 1, 0: 1, 4: 2, 2: 3, 6: 4}[a];
                    const l = h * s / 8, f = r * l;
                    let c = new Uint8Array(n * f), _ = 0, u = 0, w = 33;
                    const g = [];
                    let d, p;
                    const m = t.length - 5;
                    let b;
                    for (; 1229278788 !== (b = e.getUint32(4 + w));) {
                        if (1229209940 === b) g.push(t.subarray(8 + w, 8 + w + e.getUint32(w))); else if (1347179589 === b) {
                            if (d) throw new Error("PLTE can only occur once in an image");
                            d = new Uint32Array(e.getUint32(w));
                            for (let e = 0; e < 8 * d.length; e += 3) d[e / 3] = t[8 + w + e] << 24 | t[8 + w + e + 1] << 16 | t[8 + w + e + 2] << 8 | 255
                        } else if (1951551059 === b) {
                            if (p) throw new Error("tRNS can only occur once in an image");
                            p = new Uint8Array(e.getUint32(w));
                            for (let e = 0; e < p.length; e++) p[e] = t[8 + w + e]
                        }
                        if (w += 12 + e.getUint32(w), w > m) break
                    }
                    for (t = o(1 === g.length ? g[0] : i.from_parts(g), n + n * f); _ < t.byteLength;) {
                        const e = t[_++], r = t.subarray(_, _ += f);
                        0 === e ? c.set(r, u) : 1 === e ? this.filter_1(r, c, u, l, f) : 2 === e ? this.filter_2(r, c, u, l, f) : 3 === e ? this.filter_3(r, c, u, l, f) : 4 === e && this.filter_4(r, c, u, l, f), u += f
                    }
                    if (3 === a) {
                        if (!d) throw new Error("Indexed color PNG has no PLTE");
                        if (p) for (let t = 0; t < p.length; t++) d[t] &= 4294967040 | p[t];
                        h = 4;
                        const t = new Uint8Array(r * n * 4), e = new DataView(t.buffer, t.byteOffset, t.byteLength);
                        for (let t = 0; t < c.length; t++) e.setUint32(4 * t, d[c[t]], !1);
                        c = t
                    }
                    if (8 !== s) {
                        const t = new Uint8Array(c.length / s * 8);
                        for (let e = 0; e < c.length; e += 2) t[e / 2] = c[e];
                        c = t
                    }
                    if (4 !== h) {
                        const t = new Uint8Array(r * n * 4), e = new DataView(t.buffer);
                        if (1 === h) for (let t = 0; t < r * n; t++) {
                            const r = c[t];
                            e.setUint32(4 * t, r << 24 | r << 16 | r << 8 | 255, !1)
                        } else if (2 === h) for (let t = 0; t < r * n * 2; t += 2) {
                            const r = c[t];
                            e.setUint32(2 * t, r << 24 | r << 16 | r << 8 | c[t + 1], !1)
                        } else if (3 === h) {
                            t.fill(255);
                            for (let e = 0; e < r * n; e++) t.set(c.subarray(3 * e, 3 * e + 3), 4 * e)
                        }
                        c = t
                    }
                    return {width: r, height: n, pixels: c}
                }, filter_1(t, e, r, i, n) {
                    let s = 0;
                    for (; s < i;) e[s + r] = t[s++];
                    for (; s < n;) e[s + r] = t[s] + e[s++ + r - i]
                }, filter_2(t, e, r, i, n) {
                    if (0 === r) e.set(t, r); else {
                        let i = 0;
                        for (; i < n;) e[i + r] = t[i] + e[i++ + r - n]
                    }
                }, filter_3(t, e, r, i, n) {
                    let s = 0;
                    if (0 === r) {
                        for (; s < i;) e[s] = t[s++];
                        for (; s < n;) e[s] = t[s] + (e[s++ - i] >> 1)
                    } else {
                        for (; s < i;) e[s + r] = t[s] + (e[s++ + r - n] >> 1);
                        for (; s < n;) e[s + r] = t[s] + (e[s + r - i] + e[s++ + r - n] >> 1)
                    }
                }, filter_4(t, e, r, i, n) {
                    let s = 0;
                    if (0 === r) {
                        for (; s < i;) e[s] = t[s++];
                        for (; s < n;) e[s] = t[s] + e[s++ - i]
                    } else {
                        for (; s < i;) e[s + r] = t[s] + e[s++ + r - n];
                        for (; s < n;) {
                            const o = e[s + r - i], a = e[s + r - n], h = e[s + r - i - n], l = o + a - h,
                                f = Math.abs(l - o), c = Math.abs(l - a), _ = Math.abs(l - h);
                            e[s + r] = t[s++] + (f <= c && f <= _ ? o : c <= _ ? a : h)
                        }
                    }
                }
            }
        }, 820: (t, e, r) => {
            const {version: i} = r(147);
            let n = null;
            t.exports = {
                async init() {
                    if (!n) {
                        const t = "compileStreaming" in WebAssembly;
                        n = await WebAssembly[t ? "compileStreaming" : "compile"](await fetch(`https://unpkg.com/imagescript@${i}/wasm/any/font.wasm`).then((e => t ? e : e.arrayBuffer())))
                    }
                    return this.new()
                }, new() {
                    let t = null;
                    const e = new WebAssembly.Instance(n).exports;

                    class r {
                        static length() {
                            return e.wlen()
                        }

                        static alloc(t) {
                            return e.walloc(t)
                        }

                        static free(t, r) {
                            return e.wfree(t, r)
                        }

                        static u8(t, r) {
                            return new Uint8Array(e.memory.buffer, t, r)
                        }

                        static u32(t, r) {
                            return new Uint32Array(e.memory.buffer, t, r)
                        }

                        static copy_and_free(t, i) {
                            let n = r.u8(t, i).slice();
                            return e.wfree(t, i), n
                        }
                    }

                    const i = "Deno" in globalThis ? Deno.core.encode : (() => {
                        const t = new TextEncoder;
                        return e => t.encode(e)
                    })(), s = "Deno" in globalThis ? Deno.core.decode : (() => {
                        const t = new TextDecoder;
                        return e => t.decode(e)
                    })();
                    return "FinalizationRegistry" in globalThis && (t = new FinalizationRegistry((([t, r]) => {
                        0 === t && e.font_free(r), 1 === t && e.layout_free(r)
                    }))), {
                        Font: class {
                            constructor(i, n) {
                                this.scale = i;
                                const s = r.alloc(n.length);
                                if (r.u8(s, n.length).set(n), this.ptr = e.font_new(s, n.length, i), !this.ptr) throw new Error("invalid font");
                                t && t.register(this, [0, this.ptr], this)
                            }

                            free() {
                                this.ptr = e.font_free(this.ptr), t && t.unregister(this)
                            }

                            has(t) {
                                return e.font_has(this.ptr, String.prototype.charCodeAt.call(t, 0))
                            }

                            metrics(t, i = this.scale) {
                                const n = e.font_metrics(this.ptr, String.prototype.charCodeAt.call(t, 0), i),
                                    o = JSON.parse(s(r.u8(e.font_metrics_buffer(n), r.length())));
                                return e.font_metrics_free(n), o
                            }

                            rasterize(t, i = this.scale) {
                                const n = e.font_rasterize(this.ptr, String.prototype.charCodeAt.call(t, 0), i), o = {
                                    buffer: r.u8(e.font_rasterize_buffer(n), r.length()).slice(),
                                    metrics: JSON.parse(s(r.u8(e.font_rasterize_metrics(n), r.length())))
                                };
                                return e.font_rasterize_free(n), o
                            }
                        }, Layout: class {
                            constructor() {
                                this.ptr = e.layout_new(), t && (this.refs = []), t && t.register(this, [1, this.ptr], this)
                            }

                            clear() {
                                e.layout_clear(this.ptr), t && (this.refs.length = 0)
                            }

                            lines() {
                                return e.layout_lines(this.ptr)
                            }

                            free() {
                                t && (this.refs.length = 0), this.ptr = e.layout_free(this.ptr), t && t.unregister(this)
                            }

                            reset(n = {}) {
                                n = i(JSON.stringify(n)), t && (this.refs.length = 0);
                                const s = r.alloc(n.length);
                                r.u8(s, n.length).set(n), e.layout_reset(this.ptr, s, n.length)
                            }

                            append(n, s, o) {
                                s = i(s);
                                const a = o || {};
                                t && this.refs.push(n);
                                const h = r.alloc(s.length);
                                r.u8(h, s.length).set(s);
                                const l = "r" in a || "g" in a || "b" in a;
                                e.layout_append(this.ptr, n.ptr, h, s.length, null == a.scale ? n.scale : a.scale, l, a.r, a.g, a.b)
                            }

                            rasterize(t, i, n) {
                                const s = e.layout_rasterize(this.ptr, t, i, n), o = {
                                    width: e.layout_rasterize_width(s),
                                    height: e.layout_rasterize_height(s),
                                    buffer: r.u8(e.layout_rasterize_buffer(s), r.length()).slice()
                                };
                                return e.layout_rasterize_free(s), o
                            }
                        }
                    }
                }
            }
        }, 584: (t, e, r) => {
            const {version: i} = r(147);
            let n = null;
            t.exports = {
                async init() {
                    if (!n) {
                        const t = "compileStreaming" in WebAssembly;
                        n = await WebAssembly[t ? "compileStreaming" : "compile"](await fetch(`https://unpkg.com/imagescript@${i}/wasm/any/gif.wasm`).then((e => t ? e : e.arrayBuffer())))
                    }
                    return this.new()
                }, new() {
                    const t = new Map, e = new TextEncoder, r = new WebAssembly.Instance(n, {
                        env: {
                            push_to_stream(e, r) {
                                t.get(e).cb(i.u8(r, i.length()).slice())
                            }
                        }
                    }).exports;

                    class i {
                        static length() {
                            return r.wlen()
                        }

                        static alloc(t) {
                            return r.walloc(t)
                        }

                        static free(t, e) {
                            return r.wfree(t, e)
                        }

                        static u8(t, e) {
                            return new Uint8Array(r.memory.buffer, t, e)
                        }

                        static u32(t, e) {
                            return new Uint32Array(r.memory.buffer, t, e)
                        }

                        static copy_and_free(t, e) {
                            let n = i.u8(t, e).slice();
                            return r.wfree(t, e), n
                        }
                    }

                    return {
                        Encoder: class {
                            constructor(e, i, n = -1) {
                                this.slices = [], t.set(0, this), this.ptr = r.encoder_new(0, e, i, n)
                            }

                            cb(t) {
                                this.slices.push(t)
                            }

                            free() {
                                this.ptr = r.encoder_free(this.ptr), t.delete(0)
                            }

                            u8() {
                                this.free();
                                let t = 0;
                                const e = new Uint8Array(this.slices.reduce(((t, e) => t + e.length), 0));
                                for (const r of this.slices) e.set(r, t), t += r.length;
                                return e
                            }

                            add(t, e, n, s, o, a, h, l) {
                                const f = i.alloc(a.length);
                                i.u8(f, a.length).set(a), r.encoder_add(this.ptr, f, a.length, t, e, s, o, n, h, l)
                            }

                            set comment(t) {
                                const n = e.encode(t), s = i.alloc(n.length);
                                i.u8(s, n.length).set(n), r.encoder_add_comment(this.ptr, s, n.length)
                            }

                            set application(t) {
                                const n = e.encode(t), s = i.alloc(n.length);
                                i.u8(s, n.length).set(n), r.encoder_add_application(this.ptr, s, n.length)
                            }
                        }, Decoder: class {
                            constructor(t, e = 0) {
                                const n = i.alloc(t.length);
                                if (i.u8(n, t.length).set(t), this.ptr = r.decoder_new(n, t.length, e), 0 === this.ptr) throw new Error("gif: failed to parse gif header");
                                this.width = r.decoder_width(this.ptr), this.height = r.decoder_height(this.ptr)
                            }

                            free() {
                                this.ptr = r.decoder_free(this.ptr)
                            }

                            * frames() {
                                let t;
                                for (; t = this.frame();) yield t
                            }

                            frame() {
                                const t = r.decoder_frame(this.ptr);
                                if (1 === t) return null;
                                if (0 === t) throw this.free(), new Error("gif: failed to decode frame");
                                const e = {
                                    x: r.decoder_frame_x(t),
                                    y: r.decoder_frame_y(t),
                                    delay: r.decoder_frame_delay(t),
                                    width: r.decoder_frame_width(t),
                                    height: r.decoder_frame_height(t),
                                    dispose: r.decoder_frame_dispose(t),
                                    buffer: i.u8(r.decoder_frame_buffer(t), i.length()).slice()
                                };
                                return r.decoder_frame_free(t), e
                            }
                        }
                    }
                }
            }
        }, 501: (t, e, r) => {
            const {version: i} = r(147);
            let n = null;
            t.exports = {
                async init() {
                    if (!n) {
                        const t = "compileStreaming" in WebAssembly;
                        n = await WebAssembly[t ? "compileStreaming" : "compile"](await fetch(`https://unpkg.com/imagescript@${i}/wasm/any/jpeg.wasm`).then((e => t ? e : e.arrayBuffer())))
                    }
                    return this.new()
                }, new() {
                    const t = new WebAssembly.Instance(n).exports;

                    class e {
                        static length() {
                            return t.wlen()
                        }

                        static alloc(e) {
                            return t.walloc(e)
                        }

                        static free(e, r) {
                            return t.wfree(e, r)
                        }

                        static u8(e, r) {
                            return new Uint8Array(t.memory.buffer, e, r)
                        }

                        static u32(e, r) {
                            return new Uint32Array(t.memory.buffer, e, r)
                        }

                        static copy_and_free(r, i) {
                            let n = e.u8(r, i).slice();
                            return t.wfree(r, i), n
                        }
                    }

                    return {
                        encode: function (r, i, n, s) {
                            const o = e.alloc(r.length);
                            return e.u8(o, r.length).set(r), e.copy_and_free(t.encode(o, i, n, s), e.length())
                        }, decode: function (r, i, n) {
                            const s = e.alloc(r.length);
                            e.u8(s, r.length).set(r);
                            const o = t.decode(s, r.length, i, n);
                            if (0 === o) throw new Error("jpg: failed to decode");
                            if (1 === o) throw new Error("jpg: failed to scale decoder");
                            const a = {
                                width: t.decode_width(o),
                                height: t.decode_height(o),
                                format: t.decode_format(o),
                                buffer: e.u8(t.decode_buffer(o), e.length()).slice()
                            };
                            return t.decode_free(o), a
                        }
                    }
                }
            }
        }, 338: (t, e, r) => {
            const {version: i} = r(147);
            let n = null;
            t.exports = {
                async init() {
                    if (!n) {
                        const t = "compileStreaming" in WebAssembly;
                        n = await WebAssembly[t ? "compileStreaming" : "compile"](await fetch(`https://unpkg.com/imagescript@${i}/wasm/any/svg.wasm`).then((e => t ? e : e.arrayBuffer())))
                    }
                    return this.new()
                }, new() {
                    const t = new WebAssembly.Instance(n).exports;

                    class e {
                        static length() {
                            return t.wlen()
                        }

                        static alloc(e) {
                            return t.walloc(e)
                        }

                        static free(e, r) {
                            return t.wfree(e, r)
                        }

                        static u8(e, r) {
                            return new Uint8Array(t.memory.buffer, e, r)
                        }

                        static u32(e, r) {
                            return new Uint32Array(t.memory.buffer, e, r)
                        }

                        static copy_and_free(r, i) {
                            let n = e.u8(r, i).slice();
                            return t.wfree(r, i), n
                        }
                    }

                    return {
                        rasterize: function (r, i, n) {
                            const s = e.alloc(r.length);
                            e.u8(s, r.length).set(r);
                            const o = t.rasterize(s, r.length, i, n);
                            if (0 === o) throw new Error("svg: failed to parse");
                            if (1 === o) throw new Error("svg: failed to rasterize");
                            const a = {
                                width: t.rasterize_width(o),
                                height: t.rasterize_height(o),
                                buffer: e.u8(t.rasterize_buffer(o), e.length()).slice()
                            };
                            return t.rasterize_free(o), a
                        }
                    }
                }
            }
        }, 193: (t, e, r) => {
            const {version: i} = r(147);
            let n = null;
            t.exports = {
                async init() {
                    if (!n) {
                        const t = "compileStreaming" in WebAssembly;
                        n = await WebAssembly[t ? "compileStreaming" : "compile"](await fetch(`https://unpkg.com/imagescript@${i}/wasm/any/tiff.wasm`).then((e => t ? e : e.arrayBuffer())))
                    }
                    return this.new()
                }, new() {
                    const t = new WebAssembly.Instance(n).exports;

                    class e {
                        static length() {
                            return t.wlen()
                        }

                        static alloc(e) {
                            return t.walloc(e)
                        }

                        static free(e, r) {
                            return t.wfree(e, r)
                        }

                        static u8(e, r) {
                            return new Uint8Array(t.memory.buffer, e, r)
                        }

                        static u32(e, r) {
                            return new Uint32Array(t.memory.buffer, e, r)
                        }

                        static copy_and_free(r, i) {
                            let n = e.u8(r, i).slice();
                            return t.wfree(r, i), n
                        }
                    }

                    return {
                        decode: function (r) {
                            const i = e.alloc(r.length);
                            e.u8(i, r.length).set(r);
                            const n = t.decode(i, r.length);
                            if (0 === n) throw new Error("tiff: failed to decode");
                            const s = {
                                width: t.decode_width(n),
                                height: t.decode_height(n),
                                buffer: e.u8(t.decode_buffer(n), e.length()).slice()
                            };
                            return t.decode_free(n), s
                        }
                    }
                }
            }
        }, 223: t => {
            var e = Uint8Array, r = Uint16Array, i = Uint32Array,
                n = new e([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]),
                s = new e([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]),
                o = new e([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), a = function (t, e) {
                    for (var n = new r(31), s = 0; s < 31; ++s) n[s] = e += 1 << t[s - 1];
                    var o = new i(n[30]);
                    for (s = 1; s < 30; ++s) for (var a = n[s]; a < n[s + 1]; ++a) o[a] = a - n[s] << 5 | s;
                    return [n, o]
                }, h = a(n, 2), l = h[0], f = h[1];
            l[28] = 258, f[258] = 28;
            for (var c, _ = a(s, 0), u = _[0], w = _[1], g = new r(32768), d = 0; d < 32768; ++d) c = (61680 & (c = (52428 & (c = (43690 & d) >>> 1 | (21845 & d) << 1)) >>> 2 | (13107 & c) << 2)) >>> 4 | (3855 & c) << 4, g[d] = ((65280 & c) >>> 8 | (255 & c) << 8) >>> 1;
            var p = function (t, e, i) {
                for (var n = t.length, s = 0, o = new r(e); s < n; ++s) ++o[t[s] - 1];
                var a, h = new r(e);
                for (s = 0; s < e; ++s) h[s] = h[s - 1] + o[s - 1] << 1;
                if (i) {
                    a = new r(1 << e);
                    var l = 15 - e;
                    for (s = 0; s < n; ++s) if (t[s]) for (var f = s << 4 | t[s], c = e - t[s], _ = h[t[s] - 1]++ << c, u = _ | (1 << c) - 1; _ <= u; ++_) a[g[_] >>> l] = f
                } else for (a = new r(n), s = 0; s < n; ++s) t[s] && (a[s] = g[h[t[s] - 1]++] >>> 15 - t[s]);
                return a
            }, m = new e(288);
            for (d = 0; d < 144; ++d) m[d] = 8;
            for (d = 144; d < 256; ++d) m[d] = 9;
            for (d = 256; d < 280; ++d) m[d] = 7;
            for (d = 280; d < 288; ++d) m[d] = 8;
            var b = new e(32);
            for (d = 0; d < 32; ++d) b[d] = 5;
            var y = p(m, 9, 0), v = p(m, 9, 1), E = p(b, 5, 0), A = p(b, 5, 1), x = function (t) {
                for (var e = t[0], r = 1; r < t.length; ++r) t[r] > e && (e = t[r]);
                return e
            }, S = function (t, e, r) {
                var i = e >> 3 | 0;
                return (t[i] | t[i + 1] << 8) >> (7 & e) & r
            }, I = function (t, e) {
                var r = e >> 3 | 0;
                return (t[r] | t[r + 1] << 8 | t[r + 2] << 16) >> (7 & e)
            }, U = function (t) {
                return (t >> 3 | 0) + (7 & t && 1)
            }, R = function (t, n, s) {
                (null == n || n < 0) && (n = 0), (null == s || s > t.length) && (s = t.length);
                var o = new (t instanceof r ? r : t instanceof i ? i : e)(s - n);
                return o.set(t.subarray(n, s)), o
            }, T = function (t, e, r) {
                r <<= 7 & e;
                var i = e >> 3 | 0;
                t[i] |= r, t[i + 1] |= r >>> 8
            }, M = function (t, e, r) {
                r <<= 7 & e;
                var i = e >> 3 | 0;
                t[i] |= r, t[i + 1] |= r >>> 8, t[i + 2] |= r >>> 16
            }, O = function (t, i) {
                for (var n = [], s = 0; s < t.length; ++s) t[s] && n.push({s, f: t[s]});
                var o = n.length, a = n.slice();
                if (!o) return [D, 0];
                if (1 === o) {
                    var h = new e(n[0].s + 1);
                    return h[n[0].s] = 1, [h, 1]
                }
                n.sort((function (t, e) {
                    return t.f - e.f
                })), n.push({s: -1, f: 25001});
                var l = n[0], f = n[1], c = 0, _ = 1, u = 2;
                for (n[0] = {
                    s: -1,
                    f: l.f + f.f,
                    l,
                    r: f
                }; _ !== o - 1;) l = n[n[c].f < n[u].f ? c++ : u++], f = n[c !== _ && n[c].f < n[u].f ? c++ : u++], n[_++] = {
                    s: -1,
                    f: l.f + f.f,
                    l,
                    r: f
                };
                var w = a[0].s;
                for (s = 1; s < o; ++s) a[s].s > w && (w = a[s].s);
                var g = new r(w + 1), d = N(n[_ - 1], g, 0);
                if (d > i) {
                    s = 0;
                    var p = 0, m = d - i, b = 1 << m;
                    for (a.sort((function (t, e) {
                        return g[e.s] - g[t.s] || t.f - e.f
                    })); s < o; ++s) {
                        var y = a[s].s;
                        if (!(g[y] > i)) break;
                        p += b - (1 << d - g[y]), g[y] = i
                    }
                    for (p >>>= m; p > 0;) {
                        var v = a[s].s;
                        g[v] < i ? p -= 1 << i - g[v]++ - 1 : ++s
                    }
                    for (; s >= 0 && p; --s) {
                        var E = a[s].s;
                        g[E] === i && (--g[E], ++p)
                    }
                    d = i
                }
                return [new e(g), d]
            }, N = function (t, e, r) {
                return -1 === t.s ? Math.max(N(t.l, e, r + 1), N(t.r, e, r + 1)) : e[t.s] = r
            }, G = function (t) {
                for (var e = t.length; e && !t[--e];) ;
                for (var i = new r(++e), n = 0, s = t[0], o = 1, a = function (t) {
                    i[n++] = t
                }, h = 1; h <= e; ++h) if (t[h] === s && h !== e) ++o; else {
                    if (!s && o > 2) {
                        for (; o > 138; o -= 138) a(32754);
                        o > 2 && (a(o > 10 ? o - 11 << 5 | 28690 : o - 3 << 5 | 12305), o = 0)
                    } else if (o > 3) {
                        for (a(s), --o; o > 6; o -= 6) a(8304);
                        o > 2 && (a(o - 3 << 5 | 8208), o = 0)
                    }
                    for (; o--;) a(s);
                    o = 1, s = t[h]
                }
                return [i.subarray(0, n), e]
            }, B = function (t, e) {
                for (var r = 0, i = 0; i < e.length; ++i) r += t[i] * e[i];
                return r
            }, z = function (t, e, r) {
                var i = r.length, n = U(e + 2);
                t[n] = 255 & i, t[n + 1] = i >>> 8, t[n + 2] = 255 ^ t[n], t[n + 3] = 255 ^ t[n + 1];
                for (var s = 0; s < i; ++s) t[n + s + 4] = r[s];
                return 8 * (n + 4 + i)
            }, C = function (t, e, i, a, h, l, f, c, _, u, w) {
                T(e, w++, i), ++h[256];
                for (var g = O(h, 15), d = g[0], v = g[1], A = O(l, 15), x = A[0], S = A[1], I = G(d), U = I[0], R = I[1], N = G(x), C = N[0], H = N[1], D = new r(19), L = 0; L < U.length; ++L) D[31 & U[L]]++;
                for (L = 0; L < C.length; ++L) D[31 & C[L]]++;
                for (var k = O(D, 7), W = k[0], V = k[1], $ = 19; $ > 4 && !W[o[$ - 1]]; --$) ;
                var F, P, Z, j, J = u + 5 << 3, K = B(h, m) + B(l, b) + f,
                    q = B(h, d) + B(l, x) + f + 14 + 3 * $ + B(D, W) + (2 * D[16] + 3 * D[17] + 7 * D[18]);
                if (J <= K && J <= q) return z(e, w, t.subarray(_, _ + u));
                if (T(e, w, 1 + (q < K)), w += 2, q < K) {
                    F = p(d, v, 0), P = d, Z = p(x, S, 0), j = x;
                    var Q = p(W, V, 0);
                    for (T(e, w, R - 257), T(e, w + 5, H - 1), T(e, w + 10, $ - 4), w += 14, L = 0; L < $; ++L) T(e, w + 3 * L, W[o[L]]);
                    w += 3 * $;
                    for (var X = [U, C], Y = 0; Y < 2; ++Y) {
                        var tt = X[Y];
                        for (L = 0; L < tt.length; ++L) {
                            var et = 31 & tt[L];
                            T(e, w, Q[et]), w += W[et], et > 15 && (T(e, w, tt[L] >>> 5 & 127), w += tt[L] >>> 12)
                        }
                    }
                } else F = y, P = m, Z = E, j = b;
                for (L = 0; L < c; ++L) if (a[L] > 255) {
                    et = a[L] >>> 18 & 31, M(e, w, F[et + 257]), w += P[et + 257], et > 7 && (T(e, w, a[L] >>> 23 & 31), w += n[et]);
                    var rt = 31 & a[L];
                    M(e, w, Z[rt]), w += j[rt], rt > 3 && (M(e, w, a[L] >>> 5 & 8191), w += s[rt])
                } else M(e, w, F[a[L]]), w += P[a[L]];
                return M(e, w, F[256]), w + P[256]
            }, H = new i([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), D = new e(0);
            t.exports = {
                compress: function (t, o) {
                    return function (t, o) {
                        o || (o = {});
                        var a = function () {
                            var t = 1, e = 0;
                            return {
                                p: function (r) {
                                    for (var i = t, n = e, s = 0 | r.length, o = 0; o !== s;) {
                                        for (var a = Math.min(o + 2655, s); o < a; ++o) n += i += r[o];
                                        i = (65535 & i) + 15 * (i >> 16), n = (65535 & n) + 15 * (n >> 16)
                                    }
                                    t = i, e = n
                                }, d: function () {
                                    return (255 & (t %= 65521)) << 24 | t >>> 8 << 16 | (255 & (e %= 65521)) << 8 | e >>> 8
                                }
                            }
                        }();
                        a.p(t);
                        var h, l, c, _, u, g, d, p, m = (c = 2, _ = 4, function (t, o, a, h, l, c) {
                            var _ = t.length, u = new e(h + _ + 5 * (1 + Math.ceil(_ / 7e3)) + l),
                                g = u.subarray(h, u.length - l), d = 0;
                            if (!o || _ < 8) for (var p = 0; p <= _; p += 65535) {
                                var m = p + 65535;
                                m < _ ? d = z(g, d, t.subarray(p, m)) : (g[p] = c, d = z(g, d, t.subarray(p, _)))
                            } else {
                                for (var b = H[o - 1], y = b >>> 13, v = 8191 & b, E = (1 << a) - 1, A = new r(32768), x = new r(E + 1), S = Math.ceil(a / 3), I = 2 * S, T = function (e) {
                                    return (t[e] ^ t[e + 1] << S ^ t[e + 2] << I) & E
                                }, M = new i(25e3), O = new r(288), N = new r(32), G = 0, B = 0, L = (p = 0, 0), k = 0, W = 0; p < _; ++p) {
                                    var V = T(p), $ = 32767 & p, F = x[V];
                                    if (A[$] = F, x[V] = $, k <= p) {
                                        var P = _ - p;
                                        if ((G > 7e3 || L > 24576) && P > 423) {
                                            d = C(t, g, 0, M, O, N, B, L, W, p - W, d), L = G = B = 0, W = p;
                                            for (var Z = 0; Z < 286; ++Z) O[Z] = 0;
                                            for (Z = 0; Z < 30; ++Z) N[Z] = 0
                                        }
                                        var j = 2, J = 0, K = v, q = $ - F & 32767;
                                        if (P > 2 && V === T(p - q)) for (var Q = Math.min(y, P) - 1, X = Math.min(32767, p), Y = Math.min(258, P); q <= X && --K && $ !== F;) {
                                            if (t[p + j] === t[p + j - q]) {
                                                for (var tt = 0; tt < Y && t[p + tt] === t[p + tt - q]; ++tt) ;
                                                if (tt > j) {
                                                    if (j = tt, J = q, tt > Q) break;
                                                    var et = Math.min(q, tt - 2), rt = 0;
                                                    for (Z = 0; Z < et; ++Z) {
                                                        var it = p - q + Z + 32768 & 32767,
                                                            nt = it - A[it] + 32768 & 32767;
                                                        nt > rt && (rt = nt, F = it)
                                                    }
                                                }
                                            }
                                            q += ($ = F) - (F = A[$]) + 32768 & 32767
                                        }
                                        if (J) {
                                            M[L++] = 268435456 | f[j] << 18 | w[J];
                                            var st = 31 & f[j], ot = 31 & w[J];
                                            B += n[st] + s[ot], ++O[257 + st], ++N[ot], k = p + j, ++G
                                        } else M[L++] = t[p], ++O[t[p]]
                                    }
                                }
                                d = C(t, g, c, M, O, N, B, L, W, p - W, d), !c && 7 & d && (d = z(g, d + 1, D))
                            }
                            return R(u, 0, h + U(d) + l)
                        }(h = t, null == (l = o).level ? 6 : l.level, null == l.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(h.length)))) : 12 + l.mem, c, _, !u));
                        return g = m, d = o.level, p = 0 === d ? 0 : d < 6 ? 1 : 9 === d ? 3 : 2, g[0] = 120, g[1] = p << 6 | (p ? 32 - 2 * p : 1), function (t, e, r) {
                            for (; r; ++e) t[e] = r, r >>>= 8
                        }(m, m.length - 4, a.d()), m
                    }(t, {level: o})
                }, decompress: function (t, r) {
                    return i = t, a = new Uint8Array(r), function (t, r, i) {
                        var a = t.length;
                        if (!a || i && !i.l && a < 5) return r || new e(0);
                        var h = !r || i, f = !i || i.i;
                        i || (i = {}), r || (r = new e(3 * a));
                        var c = function (t) {
                            var i = r.length;
                            if (t > i) {
                                var n = new e(Math.max(2 * i, t));
                                n.set(r), r = n
                            }
                        }, _ = i.f || 0, w = i.p || 0, g = i.b || 0, d = i.l, m = i.d, b = i.m, y = i.n, E = 8 * a;
                        do {
                            if (!d) {
                                i.f = _ = S(t, w, 1);
                                var T = S(t, w + 1, 3);
                                if (w += 3, !T) {
                                    var M = t[(W = U(w) + 4) - 4] | t[W - 3] << 8, O = W + M;
                                    if (O > a) {
                                        if (f) throw "unexpected EOF";
                                        break
                                    }
                                    h && c(g + M), r.set(t.subarray(W, O), g), i.b = g += M, i.p = w = 8 * O;
                                    continue
                                }
                                if (1 === T) d = v, m = A, b = 9, y = 5; else {
                                    if (2 !== T) throw "invalid block type";
                                    var N = S(t, w, 31) + 257, G = S(t, w + 10, 15) + 4, B = N + S(t, w + 5, 31) + 1;
                                    w += 14;
                                    for (var z = new e(B), C = new e(19), H = 0; H < G; ++H) C[o[H]] = S(t, w + 3 * H, 7);
                                    w += 3 * G;
                                    var D = x(C), L = (1 << D) - 1, k = p(C, D, 1);
                                    for (H = 0; H < B;) {
                                        var W, V = k[S(t, w, L)];
                                        if (w += 15 & V, (W = V >>> 4) < 16) z[H++] = W; else {
                                            var $ = 0, F = 0;
                                            for (16 === W ? (F = 3 + S(t, w, 3), w += 2, $ = z[H - 1]) : 17 === W ? (F = 3 + S(t, w, 7), w += 3) : 18 === W && (F = 11 + S(t, w, 127), w += 7); F--;) z[H++] = $
                                        }
                                    }
                                    var P = z.subarray(0, N), Z = z.subarray(N);
                                    b = x(P), y = x(Z), d = p(P, b, 1), m = p(Z, y, 1)
                                }
                                if (w > E) {
                                    if (f) throw "unexpected EOF";
                                    break
                                }
                            }
                            h && c(g + 131072);
                            for (var j = (1 << b) - 1, J = (1 << y) - 1, K = w; ; K = w) {
                                var q = ($ = d[I(t, w) & j]) >>> 4;
                                if ((w += 15 & $) > E) {
                                    if (f) throw "unexpected EOF";
                                    break
                                }
                                if (!$) throw "invalid length/literal";
                                if (q < 256) r[g++] = q; else {
                                    if (256 === q) {
                                        K = w, d = null;
                                        break
                                    }
                                    var Q = q - 254;
                                    if (q > 264) {
                                        var X = n[H = q - 257];
                                        Q = S(t, w, (1 << X) - 1) + l[H], w += X
                                    }
                                    var Y = m[I(t, w) & J], tt = Y >>> 4;
                                    if (!Y) throw "invalid distance";
                                    if (w += 15 & Y, Z = u[tt], tt > 3 && (X = s[tt], Z += I(t, w) & (1 << X) - 1, w += X), w > E) {
                                        if (f) throw "unexpected EOF";
                                        break
                                    }
                                    h && c(g + 131072);
                                    for (var et = g + Q; g < et; g += 4) r[g] = r[g - Z], r[g + 1] = r[g + 1 - Z], r[g + 2] = r[g + 2 - Z], r[g + 3] = r[g + 3 - Z];
                                    g = et
                                }
                            }
                            i.l = d, i.p = K, i.b = g, d && (_ = 1, i.m = b, i.d = m, i.n = y)
                        } while (!_);
                        return g === r.length ? r : R(r, 0, g)
                    }((function (t) {
                        if (8 != (15 & t[0]) || t[0] >>> 4 > 7 || (t[0] << 8 | t[1]) % 31) throw "invalid zlib data";
                        if (32 & t[1]) throw "invalid zlib data: preset dictionaries not supported"
                    }(i), i.subarray(2, -4)), a);
                    var i, a
                }
            }
        }, 147: t => {
            "use strict";
            t.exports = JSON.parse('{"name":"imagescript","version":"1.2.16","description":"zero-dependency javascript image manipulation","main":"ImageScript.js","types":"ImageScript.d.ts","type":"commonjs","scripts":{"build":"webpack"},"repository":{"type":"git","url":"git+https://github.com/matmen/ImageScript.git"},"keywords":["image","image processing","image manipulation","png","jpeg","jpg","scale","resize","crop","webp","svg","bitmap","gif","picture","thumbnail"],"author":"Mathis Mensing <mathis@matmen.dev>","license":"(AGPL-3.0-or-later OR MIT)","bugs":{"url":"https://github.com/matmen/ImageScript/issues"},"homepage":"https://github.com/matmen/ImageScript#readme","engines":{"node":">=14.0.0"}}')
        }
    }, e = {}, function r(i) {
        var n = e[i];
        if (void 0 !== n) return n.exports;
        var s = e[i] = {exports: {}};
        return t[i](s, s.exports, r), s.exports
    }(860);
    var t, e
}));
//# sourceMappingURL=ImageScript.js.map